import { render } from "./TdEditor.vue?vue&type=template&id=46e7d6e7"
import script from "./TdEditor.vue?vue&type=script&lang=js"
export * from "./TdEditor.vue?vue&type=script&lang=js"

import "./TdEditor.vue?vue&type=style&index=0&id=46e7d6e7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__